{
  "name": "@srgssr/svg-button",
  "version": "1.1.2",
  "license": "MIT",
  "author": "SRG SSR",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/SRGSSR/pillarbox-web-suite.git"
  },
  "publishConfig": {
    "access": "public"
  },
  "homepage": "https://github.com/SRGSSR/pillarbox-web-suite/tree/main/packages/svg-button#readme",
  "type": "module",
  "main": "dist/svg-button.cjs",
  "browser": "dist/svg-button.umd.min.js",
  "module": "dist/svg-button.js",
  "style": "./dist/svg-button.min.css",
  "exports": {
    ".": {
      "import": "./dist/svg-button.js",
      "require": "./dist/svg-button.cjs"
    },
    "./*": "./*"
  },
  "files": [
    "dist/*",
    "scss/*"
  ],
  "keywords": [
    "video.js",
    "player"
  ],
  "scripts": {
    "clean": "rimraf dist",
    "build": "npm-run-all clean build:*",
    "build:css": "sass ./scss/svg-button.scss:dist/svg-button.min.css --style compressed --source-map --load-path node_modules",
    "build:lib": "vite build --config vite.config.lib.js",
    "build:umd": "vite build --config vite.config.umd.js",
    "github:page": "vite build",
    "release:ci": "semantic-release",
    "start": " vite --port 4200 --open",
    "test": "vitest run --coverage --coverage.reporter text"
  },
  "dependencies": {
    "@srgssr/web-suite-utils": "^1.0.0"
  },
  "peerDependencies": {
    "video.js": "^8.0.0"
  },
  "devDependencies": {
    "@srgssr/pillarbox-web": "^1.24.1"
  }
}
